export default __webpack_public_path__ + "static/media/todays-trucking.3c389d00.png";